// Figma 32:202108 (Customers table) / 32:204182 (Devices & Bundles card grid): the tab strip is its
// own ~28px tall row, centred against the 40px search input, so the active tab's underline lands
// ~5px ABOVE the search box's bottom edge and sits ~22px clear of the grid. antd stretches
// `.ant-tabs-nav-wrap` (`align-self: stretch`) to the nav's height — which the taller extra content
// sets — dropping the underline flush onto the search box's bottom border and leaving only the
// nav's own 16px margin between the whole bunch and the grid (ADO 117319).
//
// `align-self` alone: `.ant-tabs-nav-wrap` keeps antd's `flex: auto`, which is what pushes the
// search input to the right edge — constraining its width here would pull the search back inwards.
//
// Four classes deliberately. antd sets the `stretch` from
// `:where(.css-hash).ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap` — the `:where()` adds nothing but
// the three classes do, so the obvious `.tabs :global(.ant-tabs-nav-wrap)` (two) silently lost and
// the first pass at this bug changed nothing on screen. Matching antd's three would only tie, and
// the winner would then turn on whether Vite's stylesheet or cssinjs's runtime <style> came last.
.tabs:global(.ant-tabs) {
  :global(.ant-tabs-nav) > :global(.ant-tabs-nav-wrap) {
    align-self: center;
  }

  // The shared `underline` variant draws a full-width rule along the nav's bottom edge. Figma
  // 32:202108 has none: the tab row and the search input float over the page, and with the nav
  // now 40px tall (the search sets it) that rule lands under the search box rather than under
  // the tabs — a line the design never draws. Three classes, to out-rank antd's own
  // `.ant-tabs-top > .ant-tabs-nav::before` (two) rather than tie with it.
  :global(.ant-tabs-nav)::before {
    display: none;
  }
}
